import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import SafeUrlAssembler from 'safe-url-assembler';
import { HttpClientService } from '../../../core/services/http/http-client.service';
import { IAnnouncement } from './models/announcement.interface';
import { IEvent } from './models/event.interface';
import { INews } from './models/news.interface';
import { ApiEndpointService } from '../../../core/services/api-endpoint.service';
import { ISiteAnnouncement } from '../../components/site-announcement/models/site-announcement.interface';

@Injectable()
export class AnnouncementService {
  constructor(private httpClientService: HttpClientService, private apiEndpointService: ApiEndpointService) {
  }

  public getAnnouncements(stationID: string): Observable<IAnnouncement[]> {
    const endpoint = SafeUrlAssembler().template(this.apiEndpointService.getEndpoint('getAnnouncements'))
      .query({
        stationID,
      })
      .toString();

    return this.httpClientService.get<IAnnouncement[]>(endpoint);
  }

  public getSiteAnnouncements(shippingStationId: string): Observable<ISiteAnnouncement[]> {
    const endpoint = SafeUrlAssembler()
      .template(this.apiEndpointService.getEndpoint('getSiteAnnouncements'))
      .param('shippingStationId', shippingStationId)
      .toString();

    return this.httpClientService.get<ISiteAnnouncement[]>(endpoint);
  }

  public getEvents(countryCode: string = 'all'): Observable<IEvent[]> {
    const endpoint = SafeUrlAssembler().template(this.apiEndpointService.getEndpoint('getEvents'))
      .query({
        countryCode,
      })
      .toString();

    return this.httpClientService.get<IEvent[]>(endpoint);
  }

  public getNews(countryCode: string = 'all'): Observable<INews[]> {
    const endpoint = SafeUrlAssembler().template(this.apiEndpointService.getEndpoint('getNews'))
      .query({
        countryCode,
      })
      .toString();

    return this.httpClientService.get<INews[]>(endpoint);
  }
}
